import { render, staticRenderFns } from "./EventsAgenda.vue?vue&type=template&id=60ac298d&scoped=true"
import script from "./EventsAgenda.vue?vue&type=script&lang=js"
export * from "./EventsAgenda.vue?vue&type=script&lang=js"
import style0 from "./EventsAgenda.vue?vue&type=style&index=0&id=60ac298d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ac298d",
  null
  
)

export default component.exports